// basics
export const NUMERIC_STRING = /^\d+$/;

// phone
export const AREA_CODE_MOBILE_STRING = /^01[5-7]\d{1,2}$/;
export const AREA_CODE_LANDLINE_STRING = /^\d{3,6}$/;

// address
export const ZIP_STRING = /^\d{5}$/;

// customer number
export const CUSTOMER_NUMBER_STRING = /^\d{10}$/;

// iban
export const IBAN_STRING = /^[A-Z]{2}\d{20}$/;
export const IBAN_MASKED_STRING = /^[A-Z]{2}\*{2}\d{4}\*{4}\d{5}\*{5}$/;

// email (see https://emailregex.com/ – same as aax uses but with case-insensitive flag and full string match)
export const EMAIL_STRING =
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/i;
